// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { GetOrderAwaitingApprovalApiParameter } from "@guestsupply/App/Services/CustomerOrderAwaitingApprovalService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";

export interface OrderAwaitingApprovalFilterListState {
    getOrderAwaitingApprovalsParameter: GetOrderAwaitingApprovalApiParameter;
}

const initialState: OrderAwaitingApprovalFilterListState = {
    getOrderAwaitingApprovalsParameter: {},
};

const reducer = {
    "Pages/OrderAwaitingApprovalList/UpdateSearchFields": (
        draft: Draft<OrderAwaitingApprovalFilterListState>,
        action: {
            parameter: GetOrderAwaitingApprovalApiParameter & UpdateSearchFieldsType;
        },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getOrderAwaitingApprovalsParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getOrderAwaitingApprovalsParameter = {
                ...initialState.getOrderAwaitingApprovalsParameter,
                ...action.parameter,
            };
        } else {
            draft.getOrderAwaitingApprovalsParameter = {
                ...draft.getOrderAwaitingApprovalsParameter,
                ...action.parameter,
            };

            for (const key in draft.getOrderAwaitingApprovalsParameter) {
                const value = (<any>draft.getOrderAwaitingApprovalsParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getOrderAwaitingApprovalsParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getOrderAwaitingApprovalsParameter.page &&
                    draft.getOrderAwaitingApprovalsParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getOrderAwaitingApprovalsParameter.page = 1;
                }
            }
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);

const xOrderAwaitingApprovalSearchFields = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xOrderAwaitingApprovalSearchFields = xOrderAwaitingApprovalSearchFields;

export type xOrderAwaitingApprovalFilterListState = {
    xOrderAwaitingApprovalSearchFields: OrderAwaitingApprovalFilterListState;
} & ApplicationState;

type xOrderAwaitingApprovalsFilterListStateReducers = {
    orderAwaitingApprovalsSearchFields: typeof xOrderAwaitingApprovalSearchFields;
};

export type xOrderAwaitingApprovalsFilterListStateActions =
    | Parameters<
          xOrderAwaitingApprovalsFilterListStateReducers[keyof xOrderAwaitingApprovalsFilterListStateReducers]
      >[1]
    | AnyAction;
